@file:OptIn(InternalResourceApi::class)

package fr.frux.core.designsystem.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/fr.frux.core.designsystem.resources/"

@delegate:ResourceContentHash(854_815_724)
public val Res.string.ds_bottom_nav_add_tree: StringResource by lazy {
      StringResource("string:ds_bottom_nav_add_tree", "ds_bottom_nav_add_tree", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 54),
      ))
    }

@delegate:ResourceContentHash(1_992_927_386)
public val Res.string.ds_error_account_suspended: StringResource by lazy {
      StringResource("string:ds_error_account_suspended", "ds_error_account_suspended", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 65, 106),
      ))
    }

@delegate:ResourceContentHash(1_358_963_139)
public val Res.string.ds_error_already_reported: StringResource by lazy {
      StringResource("string:ds_error_already_reported", "ds_error_already_reported", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 172, 73),
      ))
    }

@delegate:ResourceContentHash(-537_825_951)
public val Res.string.ds_error_attach_forbidden: StringResource by lazy {
      StringResource("string:ds_error_attach_forbidden", "ds_error_attach_forbidden", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 246, 101),
      ))
    }

@delegate:ResourceContentHash(872_341_621)
public val Res.string.ds_error_attach_too_far: StringResource by lazy {
      StringResource("string:ds_error_attach_too_far", "ds_error_attach_too_far", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 348, 107),
      ))
    }

@delegate:ResourceContentHash(283_380_387)
public val Res.string.ds_error_conflict: StringResource by lazy {
      StringResource("string:ds_error_conflict", "ds_error_conflict", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 456, 85),
      ))
    }

@delegate:ResourceContentHash(-855_497_420)
public val Res.string.ds_error_invalid: StringResource by lazy {
      StringResource("string:ds_error_invalid", "ds_error_invalid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 542, 112),
      ))
    }

@delegate:ResourceContentHash(591_979_304)
public val Res.string.ds_error_move_too_far: StringResource by lazy {
      StringResource("string:ds_error_move_too_far", "ds_error_move_too_far", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 655, 93),
      ))
    }

@delegate:ResourceContentHash(356_228_612)
public val Res.string.ds_error_network: StringResource by lazy {
      StringResource("string:ds_error_network", "ds_error_network", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 749, 108),
      ))
    }

@delegate:ResourceContentHash(2_046_093_060)
public val Res.string.ds_error_not_found: StringResource by lazy {
      StringResource("string:ds_error_not_found", "ds_error_not_found", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 858, 66),
      ))
    }

@delegate:ResourceContentHash(-1_363_374_220)
public val Res.string.ds_error_not_site_owner: StringResource by lazy {
      StringResource("string:ds_error_not_site_owner", "ds_error_not_site_owner", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 925, 103),
      ))
    }

@delegate:ResourceContentHash(208_438_917)
public val Res.string.ds_error_planting_exists: StringResource by lazy {
      StringResource("string:ds_error_planting_exists", "ds_error_planting_exists", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1029, 96),
      ))
    }

@delegate:ResourceContentHash(-528_333_798)
public val Res.string.ds_error_premium_required: StringResource by lazy {
      StringResource("string:ds_error_premium_required", "ds_error_premium_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1126, 81),
      ))
    }

@delegate:ResourceContentHash(1_935_350_620)
public val Res.string.ds_error_quota_exhausted: StringResource by lazy {
      StringResource("string:ds_error_quota_exhausted", "ds_error_quota_exhausted", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1208, 96),
      ))
    }

@delegate:ResourceContentHash(733_034_521)
public val Res.string.ds_error_rate_limited: StringResource by lazy {
      StringResource("string:ds_error_rate_limited", "ds_error_rate_limited", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1513, 109),
      ))
    }

@delegate:ResourceContentHash(-1_243_179_308)
public val Res.string.ds_error_rate_limited_minutes: StringResource by lazy {
      StringResource("string:ds_error_rate_limited_minutes", "ds_error_rate_limited_minutes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1305, 101),
      ))
    }

@delegate:ResourceContentHash(-2_113_285_239)
public val Res.string.ds_error_rate_limited_seconds: StringResource by lazy {
      StringResource("string:ds_error_rate_limited_seconds", "ds_error_rate_limited_seconds", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1407, 105),
      ))
    }

@delegate:ResourceContentHash(1_325_364_925)
public val Res.string.ds_error_self_report: StringResource by lazy {
      StringResource("string:ds_error_self_report", "ds_error_self_report", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1623, 76),
      ))
    }

@delegate:ResourceContentHash(837_437_678)
public val Res.string.ds_error_server: StringResource by lazy {
      StringResource("string:ds_error_server", "ds_error_server", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1700, 99),
      ))
    }

@delegate:ResourceContentHash(-1_176_214_424)
public val Res.string.ds_error_site_private: StringResource by lazy {
      StringResource("string:ds_error_site_private", "ds_error_site_private", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1800, 125),
      ))
    }

@delegate:ResourceContentHash(1_420_507_852)
public val Res.string.ds_error_state_retry: StringResource by lazy {
      StringResource("string:ds_error_state_retry", "ds_error_state_retry", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1926, 44),
      ))
    }

@delegate:ResourceContentHash(1_828_985_610)
public val Res.string.ds_error_state_title: StringResource by lazy {
      StringResource("string:ds_error_state_title", "ds_error_state_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1971, 60),
      ))
    }

@delegate:ResourceContentHash(386_712_699)
public val Res.string.ds_error_tree_already_attached: StringResource by lazy {
      StringResource("string:ds_error_tree_already_attached", "ds_error_tree_already_attached", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2032, 102),
      ))
    }

@delegate:ResourceContentHash(409_500_297)
public val Res.string.ds_error_unauthorized: StringResource by lazy {
      StringResource("string:ds_error_unauthorized", "ds_error_unauthorized", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2135, 93),
      ))
    }

@delegate:ResourceContentHash(1_543_154_448)
public val Res.string.ds_error_unexpected: StringResource by lazy {
      StringResource("string:ds_error_unexpected", "ds_error_unexpected", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2229, 91),
      ))
    }

@delegate:ResourceContentHash(-1_451_841_500)
public val Res.string.ds_favorite_add: StringResource by lazy {
      StringResource("string:ds_favorite_add", "ds_favorite_add", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2321, 51),
      ))
    }

@delegate:ResourceContentHash(234_662_492)
public val Res.string.ds_favorite_remove: StringResource by lazy {
      StringResource("string:ds_favorite_remove", "ds_favorite_remove", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2373, 54),
      ))
    }

@delegate:ResourceContentHash(2_045_616_636)
public val Res.string.ds_guide_body: StringResource by lazy {
      StringResource("string:ds_guide_body", "ds_guide_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2428, 309),
      ))
    }

@delegate:ResourceContentHash(-237_254_171)
public val Res.string.ds_guide_confirm: StringResource by lazy {
      StringResource("string:ds_guide_confirm", "ds_guide_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2738, 60),
      ))
    }

@delegate:ResourceContentHash(703_145_729)
public val Res.string.ds_guide_title: StringResource by lazy {
      StringResource("string:ds_guide_title", "ds_guide_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2799, 150),
      ))
    }

@delegate:ResourceContentHash(1_031_317_890)
public val Res.string.ds_moderation_block: StringResource by lazy {
      StringResource("string:ds_moderation_block", "ds_moderation_block", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3436, 71),
      ))
    }

@delegate:ResourceContentHash(-1_999_713_498)
public val Res.string.ds_moderation_block_dialog_confirm: StringResource by lazy {
      StringResource("string:ds_moderation_block_dialog_confirm", "ds_moderation_block_dialog_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2950, 54),
      ))
    }

@delegate:ResourceContentHash(-301_976_398)
public val Res.string.ds_moderation_block_dialog_text: StringResource by lazy {
      StringResource("string:ds_moderation_block_dialog_text", "ds_moderation_block_dialog_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3005, 267),
      ))
    }

@delegate:ResourceContentHash(373_706_210)
public val Res.string.ds_moderation_block_dialog_title: StringResource by lazy {
      StringResource("string:ds_moderation_block_dialog_title", "ds_moderation_block_dialog_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3273, 88),
      ))
    }

@delegate:ResourceContentHash(1_450_949_084)
public val Res.string.ds_moderation_blocked: StringResource by lazy {
      StringResource("string:ds_moderation_blocked", "ds_moderation_blocked", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3362, 73),
      ))
    }

@delegate:ResourceContentHash(-1_065_163_855)
public val Res.string.ds_moderation_cancel: StringResource by lazy {
      StringResource("string:ds_moderation_cancel", "ds_moderation_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3508, 40),
      ))
    }

@delegate:ResourceContentHash(-400_750_711)
public val Res.string.ds_moderation_content_reported: StringResource by lazy {
      StringResource("string:ds_moderation_content_reported", "ds_moderation_content_reported", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3549, 78),
      ))
    }

@delegate:ResourceContentHash(-1_655_203_763)
public val Res.string.ds_moderation_details_label: StringResource by lazy {
      StringResource("string:ds_moderation_details_label", "ds_moderation_details_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3628, 67),
      ))
    }

@delegate:ResourceContentHash(-2_127_332_127)
public val Res.string.ds_moderation_reason_harassment: StringResource by lazy {
      StringResource("string:ds_moderation_reason_harassment", "ds_moderation_reason_harassment", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3696, 55),
      ))
    }

@delegate:ResourceContentHash(-1_560_845_581)
public val Res.string.ds_moderation_reason_other: StringResource by lazy {
      StringResource("string:ds_moderation_reason_other", "ds_moderation_reason_other", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3752, 42),
      ))
    }

@delegate:ResourceContentHash(2_116_607_347)
public val Res.string.ds_moderation_reason_spam: StringResource by lazy {
      StringResource("string:ds_moderation_reason_spam", "ds_moderation_reason_spam", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3795, 41),
      ))
    }

@delegate:ResourceContentHash(1_650_976_427)
public val Res.string.ds_moderation_reason_username: StringResource by lazy {
      StringResource("string:ds_moderation_reason_username", "ds_moderation_reason_username", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3837, 65),
      ))
    }

@delegate:ResourceContentHash(-1_289_539_321)
public val Res.string.ds_moderation_report_description: StringResource by lazy {
      StringResource("string:ds_moderation_report_description", "ds_moderation_report_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3903, 72),
      ))
    }

@delegate:ResourceContentHash(2_028_884_485)
public val Res.string.ds_moderation_report_send: StringResource by lazy {
      StringResource("string:ds_moderation_report_send", "ds_moderation_report_send", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3976, 65),
      ))
    }

@delegate:ResourceContentHash(-2_103_348_543)
public val Res.string.ds_moderation_report_sheet_text: StringResource by lazy {
      StringResource("string:ds_moderation_report_sheet_text", "ds_moderation_report_sheet_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4042, 155),
      ))
    }

@delegate:ResourceContentHash(1_078_931_671)
public val Res.string.ds_moderation_report_sheet_title: StringResource by lazy {
      StringResource("string:ds_moderation_report_sheet_title", "ds_moderation_report_sheet_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4198, 60),
      ))
    }

@delegate:ResourceContentHash(2_099_462_289)
public val Res.string.ds_moderation_report_user: StringResource by lazy {
      StringResource("string:ds_moderation_report_user", "ds_moderation_report_user", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4259, 57),
      ))
    }

@delegate:ResourceContentHash(-876_115_240)
public val Res.string.ds_moderation_unblock: StringResource by lazy {
      StringResource("string:ds_moderation_unblock", "ds_moderation_unblock", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4397, 81),
      ))
    }

@delegate:ResourceContentHash(-2_039_878_967)
public val Res.string.ds_moderation_unblocked: StringResource by lazy {
      StringResource("string:ds_moderation_unblocked", "ds_moderation_unblocked", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4317, 79),
      ))
    }

@delegate:ResourceContentHash(-1_653_615_472)
public val Res.string.ds_moderation_user_reported: StringResource by lazy {
      StringResource("string:ds_moderation_user_reported", "ds_moderation_user_reported", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4479, 71),
      ))
    }

@delegate:ResourceContentHash(12_011_863)
public val Res.string.ds_needs_check_badge: StringResource by lazy {
      StringResource("string:ds_needs_check_badge", "ds_needs_check_badge", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4551, 44),
      ))
    }

@delegate:ResourceContentHash(1_535_307_061)
public val Res.string.ds_note_counter: StringResource by lazy {
      StringResource("string:ds_note_counter", "ds_note_counter", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4596, 39),
      ))
    }

@delegate:ResourceContentHash(255_430_918)
public val Res.string.ds_photo_source_camera: StringResource by lazy {
      StringResource("string:ds_photo_source_camera", "ds_photo_source_camera", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4636, 54),
      ))
    }

@delegate:ResourceContentHash(1_839_722_608)
public val Res.string.ds_photo_source_gallery: StringResource by lazy {
      StringResource("string:ds_photo_source_gallery", "ds_photo_source_gallery", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4691, 63),
      ))
    }

@delegate:ResourceContentHash(1_707_039_062)
public val Res.string.ds_sheet_close: StringResource by lazy {
      StringResource("string:ds_sheet_close", "ds_sheet_close", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4755, 30),
      ))
    }

@delegate:ResourceContentHash(-1_721_916_154)
public val Res.string.ds_top_bar_back: StringResource by lazy {
      StringResource("string:ds_top_bar_back", "ds_top_bar_back", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4786, 31),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("ds_bottom_nav_add_tree", Res.string.ds_bottom_nav_add_tree)
  map.put("ds_error_account_suspended", Res.string.ds_error_account_suspended)
  map.put("ds_error_already_reported", Res.string.ds_error_already_reported)
  map.put("ds_error_attach_forbidden", Res.string.ds_error_attach_forbidden)
  map.put("ds_error_attach_too_far", Res.string.ds_error_attach_too_far)
  map.put("ds_error_conflict", Res.string.ds_error_conflict)
  map.put("ds_error_invalid", Res.string.ds_error_invalid)
  map.put("ds_error_move_too_far", Res.string.ds_error_move_too_far)
  map.put("ds_error_network", Res.string.ds_error_network)
  map.put("ds_error_not_found", Res.string.ds_error_not_found)
  map.put("ds_error_not_site_owner", Res.string.ds_error_not_site_owner)
  map.put("ds_error_planting_exists", Res.string.ds_error_planting_exists)
  map.put("ds_error_premium_required", Res.string.ds_error_premium_required)
  map.put("ds_error_quota_exhausted", Res.string.ds_error_quota_exhausted)
  map.put("ds_error_rate_limited", Res.string.ds_error_rate_limited)
  map.put("ds_error_rate_limited_minutes", Res.string.ds_error_rate_limited_minutes)
  map.put("ds_error_rate_limited_seconds", Res.string.ds_error_rate_limited_seconds)
  map.put("ds_error_self_report", Res.string.ds_error_self_report)
  map.put("ds_error_server", Res.string.ds_error_server)
  map.put("ds_error_site_private", Res.string.ds_error_site_private)
  map.put("ds_error_state_retry", Res.string.ds_error_state_retry)
  map.put("ds_error_state_title", Res.string.ds_error_state_title)
  map.put("ds_error_tree_already_attached", Res.string.ds_error_tree_already_attached)
  map.put("ds_error_unauthorized", Res.string.ds_error_unauthorized)
  map.put("ds_error_unexpected", Res.string.ds_error_unexpected)
  map.put("ds_favorite_add", Res.string.ds_favorite_add)
  map.put("ds_favorite_remove", Res.string.ds_favorite_remove)
  map.put("ds_guide_body", Res.string.ds_guide_body)
  map.put("ds_guide_confirm", Res.string.ds_guide_confirm)
  map.put("ds_guide_title", Res.string.ds_guide_title)
  map.put("ds_moderation_block", Res.string.ds_moderation_block)
  map.put("ds_moderation_block_dialog_confirm", Res.string.ds_moderation_block_dialog_confirm)
  map.put("ds_moderation_block_dialog_text", Res.string.ds_moderation_block_dialog_text)
  map.put("ds_moderation_block_dialog_title", Res.string.ds_moderation_block_dialog_title)
  map.put("ds_moderation_blocked", Res.string.ds_moderation_blocked)
  map.put("ds_moderation_cancel", Res.string.ds_moderation_cancel)
  map.put("ds_moderation_content_reported", Res.string.ds_moderation_content_reported)
  map.put("ds_moderation_details_label", Res.string.ds_moderation_details_label)
  map.put("ds_moderation_reason_harassment", Res.string.ds_moderation_reason_harassment)
  map.put("ds_moderation_reason_other", Res.string.ds_moderation_reason_other)
  map.put("ds_moderation_reason_spam", Res.string.ds_moderation_reason_spam)
  map.put("ds_moderation_reason_username", Res.string.ds_moderation_reason_username)
  map.put("ds_moderation_report_description", Res.string.ds_moderation_report_description)
  map.put("ds_moderation_report_send", Res.string.ds_moderation_report_send)
  map.put("ds_moderation_report_sheet_text", Res.string.ds_moderation_report_sheet_text)
  map.put("ds_moderation_report_sheet_title", Res.string.ds_moderation_report_sheet_title)
  map.put("ds_moderation_report_user", Res.string.ds_moderation_report_user)
  map.put("ds_moderation_unblock", Res.string.ds_moderation_unblock)
  map.put("ds_moderation_unblocked", Res.string.ds_moderation_unblocked)
  map.put("ds_moderation_user_reported", Res.string.ds_moderation_user_reported)
  map.put("ds_needs_check_badge", Res.string.ds_needs_check_badge)
  map.put("ds_note_counter", Res.string.ds_note_counter)
  map.put("ds_photo_source_camera", Res.string.ds_photo_source_camera)
  map.put("ds_photo_source_gallery", Res.string.ds_photo_source_gallery)
  map.put("ds_sheet_close", Res.string.ds_sheet_close)
  map.put("ds_top_bar_back", Res.string.ds_top_bar_back)
}
